import { render, staticRenderFns } from "./MenuGroupLimitAddEdit.vue?vue&type=template&id=af9b689e"
import script from "./MenuGroupLimitAddEdit.vue?vue&type=script&lang=js"
export * from "./MenuGroupLimitAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports